const PS = require("./util/ParserState");
const ImageCache = require("../util/ImageCache");

// Create an image node. ps is a parser state with the text of the
// \image command argument.
// Returns a singleton array with a node of type image on success, or
// false if something went wrong. Errors will be in the parser state.
const parseImage = function(ps, altText) {
	// ps will be false if something went wrong beforehand.
	if (ps === false) {
		return false;
	}
	ps = PS.convert(ps);
	const imageArgument = ps.getRest();

	// Begin portion written by Phyllis (Palmer left this mostly untouched when
	// parser was rewritten).
	const args = imageArgument.split(";");
	if (args.length < 2) {
		args[1] = "[0,0,50,50]";
	}
	const name = args[0].trim();
	let position = [];
	let scale = null;
	let rotation = null;
	let isReflected = false;

	// This is a tweak to fix image paths for paths beginning with /assets, as it would
	// have an additional leading slash (ie //assets/) otherwise
	// This isn't done for paths not beginning with /assets
	const nameWithoutLeadingSlash = name.substr(name.startsWith("/") ? 1 : 0);
	const nameSplit = nameWithoutLeadingSlash.split("/");
	let url;
	if (nameSplit[0] === "assets") {
		//For dev use only. Allows us to put local images into Batex.
		url = global.BASE_URL + nameWithoutLeadingSlash;
	} else {
		url = global.IMAGE_UPLOAD_URL + "u/" + name;
	}
	const image = ImageCache.src(url, true);

	args[1] = args[1].trim().slice(1, args[1].length - 1);
	position = args[1].split(",");
	// If there is a 5th element, it represents a scale parameter.
	if (position.length === 5) {
		scale = parseFloat(position[4]);
		position.pop();
	}
	position = position.map(function(num) {
		return num === "null" ? null : parseInt(num);
	});
	if (args.length === 4) {
		rotation = parseInt(args[2].trim());
		isReflected = args[3].trim() === "true";
	} else if (args.length !== 2) {
		ps.pushError("Image has unexpected number of arguments.");
		return false;
	}

	return [
		{
			type: "image",
			image: image,
			position: position,
			scale: scale,
			rotation: rotation,
			isReflected: isReflected,
			altText,
		},
	];
};

module.exports = {
	parseImage: parseImage,
};
